import React from "react";
import IMG1 from "../../assets/dineout.png";
import IMG2 from "../../assets/bigbasket.jpeg";
import IMG4 from "../../assets/unsplash.png";

import "./portfolio.css";
//Portfolio function
const Portfolio = () => {
  const soloProjects = [
    {
      id: 1,
      title: "Dineout",
      img: IMG1,
      description:
        "Dineout is a online table booking website for a best restaurant experience.",
      technologies: "Html | CSS | Javascript | React Js | Redux ",
      link: "https://dineoutclone.netlify.app/",
      github: "https://github.com/suryathink/dineoutClone",
    },
    {
      id: 2,
      title: "Unsplash",
      img: IMG4,
      description:
        "Unsplash is a online pictures download web site for wallpapers and screensavers.",
      technologies: " HTML | CSS | JavaScript",
      link: "https://soft-cucurucho-b7b394.netlify.app/",
      github: "https://github.com/Ajay-bhagal/team_6",
    },
    {
      id: 3,
      title: "Bigbasket",
      img: IMG2,
      description:
        "Big basket is an online super market for all your daily needs",
      technologies: "HTML | CSS | JavaScript",
      link: "https://chipper-frangipane-171860.netlify.app/",
      github: "https://github.com/mohanrang/big_bascket",
    },
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p>{pro.technologies}</p>
            </div>
            <div className="portfolio__item-cta">
              <a
                href={pro.github}
                target="_blank"
                className="btn"
                rel="noreferrer"
              >
                GitHub
              </a>
              <a
                href={pro.link}
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
              >
                Live Demo
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
